import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Input,
} from 'antd';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import getFormatedValues from 'utils/formatValues';
import {
  baseURI,
  getVersionesVehiculares,
  patchVersionVehicular,
  postVersionVehicular,
  deleteVersionVehicular,
} from 'api/catalogos/versionVehicular';
import Select from 'components/Select';
import { getMarcasVehiculares } from 'api/catalogos';
import { getLineasDeVehiculos } from 'api/recaudacion';

export const permissionConfig = {
  permissionModel: 'versionvehicular',
};
const REPUVE = process.env.REACT_APP_ENV_NAME === 'repuve';

// eslint-disable-next-line react/prop-types
const CatalogoDeVersiones = ({ permission }) => {
  const [form] = Form.useForm();
  const marca = Form.useWatch('marca', form);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const marcas = useRef({ results: [] });
  const lineas = useRef({ results: [] });
  const [marcasTemp, setMarcasTemp] = useState([]);
  const [lineasTemp, setLineasTemp] = useState([]);

  const fetchData = async (page = 1, q) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getVersionesVehiculares({ page, ...q });
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setSelectedRowKeys([]);
    form.resetFields();
    setVisibleAlert(false);
  };

  const onFinish = async () => {
    setLoading(true);
    const { marca: _marca, ...values } = getFormatedValues(form.getFieldsValue());
    values.marca_en_version = [...marcasTemp, ...marcas.current.results]
      .find((e) => e.id === _marca).nombre;
    values.linea_en_version = [...lineasTemp, ...lineas.current.results]
      .find((e) => e.id === values.linea_vehicular).nombre;
    const [key] = selectedRowKeys;
    const saved = await (key ? patchVersionVehicular(key, values)
      : postVersionVehicular(values));
    if (saved) {
      onCancel();
      await fetchData();
    }
    setLoading(false);
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteVersionVehicular(key);
      if (deleted) {
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const onClickAdd = () => {
    setVisible(true);
    setSelectedRowKeys([]);
    form.resetFields();
  };

  const onClickEdit = async () => {
    const match = data.results.find((e) => e.id === selectedRowKeys[0]);
    const _lineas = await getLineasDeVehiculos({ id: match.linea_vehicular });
    const _marcas = await getMarcasVehiculares({ id: _lineas.results[0].marca });
    setMarcasTemp(_marcas.results);
    setLineasTemp(_lineas.results);
    form.setFieldsValue({ marca: _marcas.results[0].id });
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 80,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 300,
    },
    {
      titleText: 'Marca',
      dataIndex: 'marca_en_version',
      key: 'marca_en_version',
      width: 300,
    },
    {
      titleText: 'Línea',
      dataIndex: 'linea_en_version',
      key: 'linea_en_version',
      width: 300,
    },
  ];

  const rules = {
    required: [
      {
        required: true,
      },
    ],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible ? (
          <Table
            cols={columns}
            data={data.results}
            rowSelection={rowSelection}
            mobileColIndex={0}
            rowKey="id"
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            allowImport
            baseURI={baseURI}
            pagination={false}
            paginationCallback={fetchData}
            count={data.count}
            permission={permission}
            currentPage={currentPage}
          />
        ) : (
          <Card
            bordered={false}
            extra={(
              <FormSubmitControls
                onFinish={form.submit}
                onCancel={onCancel}
              />
            )}
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Versión `}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clave"
                    label="Clave"
                    rules={rules.required}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="descripcion"
                    label="Descripción"
                    rules={rules.required}
                  >
                    <Input maxLength={150} allowClear />
                  </Form.Item>
                </Col>
                {REPUVE ? (
                  <>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="marca"
                        label="Marca"
                        rules={rules.required}
                      >
                        <Select
                          dataSource={marcasTemp?.length ? marcasTemp : marcas.current}
                          usingExternalDataSource={Boolean(marcasTemp?.length)}
                          labelProp="nombre"
                          onClear={() => {
                            form.resetFields(['linea_vehicular']);
                            setMarcasTemp([]);
                            setLineasTemp([]);
                          }}
                          pagination={{
                            getter: getMarcasVehiculares,
                            setter: (dataSource) => {
                              marcas.current = dataSource;
                            },
                            config: { auto: true, qName: 'nombre' },
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="linea_vehicular"
                        label="Submarca"
                        rules={rules.required}
                      >
                        <Select
                          dataSource={lineasTemp?.length ? lineasTemp : lineas.current}
                          usingExternalDataSource={Boolean(lineasTemp?.length)}
                          labelProp="nombre"
                          onClear={() => {
                            setLineasTemp([]);
                          }}
                          pagination={{
                            getter: getLineasDeVehiculos,
                            setter: (dataSource) => {
                              lineas.current = dataSource;
                            },
                            config: { auto: true, qName: 'nombre' },
                            params: { marca },
                          }}
                          disabled={!marca}
                        />
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="marca_en_version"
                        label="Marca en versión"
                        rules={rules.required}
                      >
                        <Input maxLength={150} allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="linea_en_version"
                        label="Línea en versión"
                        rules={rules.required}
                      >
                        <Input maxLength={150} allowClear />
                      </Form.Item>
                    </Col>
                  </>
                )}
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Row>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => {
            setVisibleAlert(false);
            setSelectedRowKeys([]);
          }}
          visible={visibleAlert}
          content={`Version ${form.getFieldValue('descripcion')}`}
        />
      </Spin>
    </Row>
  );
};
export default CatalogoDeVersiones;
